import { render, staticRenderFns } from "./LightActivitiesCalendar.vue?vue&type=template&id=09f2ad48&lang=pug&"
import script from "./LightActivitiesCalendar.vue?vue&type=script&lang=ts&"
export * from "./LightActivitiesCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./LightActivitiesCalendar.vue?vue&type=style&index=0&id=09f2ad48&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports